import { render, staticRenderFns } from "./WebSite.vue?vue&type=template&id=33d4fd9e&scoped=true&"
import script from "./WebSite.vue?vue&type=script&lang=js&"
export * from "./WebSite.vue?vue&type=script&lang=js&"
import style0 from "./WebSite.vue?vue&type=style&index=0&id=33d4fd9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4fd9e",
  null
  
)

export default component.exports